import { KeycloakService } from 'keycloak-angular';

export function initializeKeycloak(
  keycloak: KeycloakService,
  keycloakHost: string,
) {
  return keycloak.init({
    config: {
      url: `${keycloakHost}/auth`,
      realm: 'Kontowechsel',
      clientId: 'control-panel',
    },
    initOptions: {
      checkLoginIframe: false,
      onLoad: 'login-required',
    },
  });
}
